export default "__VITE_ASSET__CbuzY5q5__"